export default __webpack_public_path__ + "static/media/modalnewNext.c5b9a434.svg";